const ar = {
  sinObra: "بدون مشروع",
  cat: { materiales: "مواد", mano_obra: "أجور العمالة", subcontratas: "مقاولون من الباطن", suministros: "مرافق (ماء وكهرباء)", fiscal: "ضرائب ورسوم" },
  rama: {
    albanil_oficial: "بنّاء ماهر", fontanero: "سبّاك", electricista: "كهربائي", carpinteria_madera: "نجارة خشب",
    carpintero_aluminio: "نجار ألمنيوم", gestion_residuos: "إدارة النفايات", transportes: "نقل",
    peones: "عمال ومساعدون", gestiones_comerciales: "مهام تجارية",
  },
  exento: { si: "معفى", marcar: "تعليم كمعفى", marcado: "تم تعليم المصروف كمعفى", quitado: "أُزيل تعليم الإعفاء", error: "تعذّر تحديث المصروف" },
  toast: {
    subida: "تم رفع الصورة", leyendo: "تم رفع الصورة · جارٍ قراءة بيانات الفاتورة…", leidos: "تمت قراءة بيانات الفاتورة تلقائيًا ✨",
    noLeidos: "تعذّرت قراءة البيانات تلقائيًا. أكملها يدويًا.", errorSubir: "تعذّر رفع الصورة",
    registrado: "تم تسجيل المصروف", eliminado: "تم حذف المصروف",
  },
  jornada: {
    titulo: "ساعات العمل لكل مشروع (الحد {{n}} ساعة/أسبوع)", totales: "{{n}} ساعة إجمالًا",
    excesoObras: "{{n}} مشروع", excesoTexto: "تتجاوز {{n}} ساعة عمل أسبوعيًا. راجع عبء العمل.",
    vacio: "لا توجد ساعات عمل مسجّلة بعد. أضف مصروفًا من فئة «أجور العمالة» مع المشروع والساعات.",
    semExcedidas: "{{n}} أسبوع متجاوز", resumen: "{{h}} ساعة · {{n}} أسبوع", excesoSemana: "تجاوز بمقدار {{h}} ساعة فوق الحد القانوني البالغ {{n}} ساعة.",
  },
  coste: { titulo: "التكلفة لكل مشروع", ver: "عرض المشاريع ←", obra: "المشروع", materiales: "مواد", manoObra: "أجور العمالة", total: "التكلفة الإجمالية" },
  vacio: { titulo: "لا توجد مصروفات", hint: "سجّل فواتير المواد والعمالة والمقاولين من الباطن" },
  tabla: { concepto: "الوصف", categoria: "الفئة", fecha: "التاريخ", horas: "الساعات", total: "الإجمالي", justificante: "المستند", justificanteM: "المستند" },
  form: {
    escanea: "امسح فاتورتك ضوئيًا ونملأ البيانات عنك", quitar: "إزالة الصورة", leyendo: "جارٍ القراءة…", camara: "المسح بالكاميرا",
    subir: "رفع ملف", analizando: "جارٍ تحليل الصورة…",
    ocrBloqueado: "يمكنك إرفاق الصورة؛ القراءة التلقائية بالذكاء الاصطناعي متاحة بدءًا من الخطة الفصلية.",
    concepto: "الوصف", categoria: "الفئة", proveedor: "المورّد / الشركة", base: "المبلغ قبل الضريبة (€)", impuesto: "الضريبة",
    obra: "المشروع", irpf: "اقتطاع IRPF (المهنيون)", sinRetencion: "بدون اقتطاع",
    isp: "الاحتساب العكسي", ispNota: "(مقاول بناء من الباطن يصدر فاتورته بدون ض.ق.م أو IGIC)",
    exento: "معفى من الضريبة", exentoNota: "(تأمينات، رسوم، إيجار سكن…)",
    horas: "الساعات", rama: "مجال العمل", datosFactura: "بيانات الفاتورة", numero: "رقم الفاتورة", hora: "وقت الشراء",
    nif: "NIF / CIF للشركة", registro: "رقم السجل التجاري", opcional: "اختياري", fecha: "التاريخ",
  },
};

export default ar;
